import { render, staticRenderFns } from "./Start.vue?vue&type=template&id=1a5d478f&scoped=true&"
import script from "./Start.vue?vue&type=script&lang=js&"
export * from "./Start.vue?vue&type=script&lang=js&"
import style0 from "../../assets/flow-design.css?vue&type=style&index=0&id=1a5d478f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5d478f",
  null
  
)

export default component.exports